import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from '../../breadcrumb.service';
import {Template} from '../../domain/template';
import {TemplateService} from '../../core/services/template-service';
import {ConfirmationService} from 'primeng/api';
import {MessageService} from 'primeng/api';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';



@Component({
    selector: 'app-templates',
    templateUrl: './templates.component.html',
    styleUrls: ['./templates.component.css'],
    providers: [MessageService, ConfirmationService]
})
export class TemplatesComponent implements OnInit {

    templates: Template[];
    cols: any[];
    selectedTemplate: Template;
    templateDialog: boolean;
    submitted: boolean;
    defaultPageSize = 10;
    totalRecords: number;
    loading = false;
    sorting = 'id,asc';
    currentPage = 0;
    filters = {};
    templateForm: FormGroup;
    editMode = false;

    constructor(private templateService: TemplateService,
                public breadcrumbService: BreadcrumbService,
                private messageService: MessageService,
                private formBuilder: FormBuilder,
                private confirmationService: ConfirmationService) {
        this.breadcrumbService.setItems([
            {label: 'Templates', routerLink: ['templates']}
        ]);
    }

    ngOnInit(): void {
        this.templateService.getTemplates(0, this.defaultPageSize, null, this.sorting).subscribe(data => {
            this.templates = data.content;
            this.totalRecords = data.totalElements;
        });
        this.cols = [
            {field: 'id', header: 'Id'},
            {field: 'iceSupplier', header: 'Ice Supplier'},
            {field: 'content', header: 'Content'},
            {field: 'supplierName', header: 'Name Supplier'},
            {field: 'fiscalId', header: 'Fiscal Id'},
            {field: 'vatIdNumber', header: 'Vat Id Number'}
        ];
        this.templateForm = this.formBuilder.group({
            id: [''],
            iceSupplier: '',
            supplierName: ['', Validators.required],
            fiscalId: '',
            vatIdNumber: '',
            content: ['', Validators.required],
        });
    }

    onRowUnselect(event) {
        console.log('Unselected:' + event.data.id);
    }

    openNew() {
        this.templateForm = this.formBuilder.group({
            id: [''],
            iceSupplier: [''],
            supplierName: ['', Validators.required],
            fiscalId: '',
            vatIdNumber: '',
            content: ['', Validators.required],
        });
        this.submitted = false;
        this.templateDialog = true;
        this.editMode = false;
    }

    hideDialog() {
        this.templateDialog = false;
        this.submitted = false;
    }

    saveTemplate() {
        this.submitted = true;
        const formValue = this.templateForm.getRawValue();
        const template = new Template(formValue.iceSupplier,
            formValue.content,
            formValue.supplierName,
            formValue.fiscalId,
            formValue.vatIdNumber);
        if (this.editMode) {
            template.id = formValue.id;
            this.templateService.updateTemplate(template)
                .subscribe(() => {
                    this.initTemplates();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Template Updated',
                        life: 3000
                    });
                }, error => {
                    console.log(error);
                });
        } else {
            this.templateService.saveTemplate(template)
                .subscribe(() => {
                    this.initTemplates();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Template Added',
                        life: 3000
                    });
                }, error => {
                    console.log(error);
                });
        }
    }

    editTemplate(template: Template) {
        this.templateForm = this.formBuilder.group({
            id: new FormControl({value: template.id, disabled: true}, Validators.required),
            iceSupplier: [template.iceSupplier],
            supplierName: [template.supplierName, Validators.required],
            fiscalId: [template.fiscalId],
            vatIdNumber: [template.vatIdNumber],
            content: [template.content, Validators.required],
        });
        this.templateDialog = true;
        this.editMode = true;
    }

    loadTemplates(event: any) {
        if (event.sortField) {
            this.sorting = event.sortField.concat(',').concat(event.sortOrder === 1 ? 'asc' : 'desc');
        }
        this.filters = event.filters;
        this.currentPage = event.first / 10;

        this.templateService.getTemplates(this.currentPage, event.rows, this.filters, this.sorting).subscribe(
            dataPaginated => {
                this.totalRecords = dataPaginated.totalElements;
                this.templates = dataPaginated.content;
                this.loading = false; // used to display loading dots in the UI
            },
            error => {
                console.log('error fetching paginated data', error);
            }
        );
    }

    deleteTemplate(template: Template) {
        console.log(template);
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the template with Id:' + template.id + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.templateService.deleteTemplate(template).subscribe(
                    () => {
                        this.initTemplates();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Template Deleted',
                            life: 3000
                        });
                    }
                );
            }
        });
    }

    initTemplates() {
        this.templateDialog = false;
        this.templateService.getTemplates(this.currentPage, this.defaultPageSize, this.filters, this.sorting).subscribe(data => {
            this.templates = data.content;
            this.totalRecords = data.totalElements;
        });
    }

    get iceSupplier() {
        return this.templateForm.get('iceSupplier');
    }

    get supplierName() {
        return this.templateForm.get('supplierName');
    }

    get fiscalId() {
        return this.templateForm.get('fiscalId');
    }

    get vatIdNumber() {
        return this.templateForm.get('vatIdNumber');
    }

    get content() {
        return this.templateForm.get('content');
    }
}
